import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import * as CommonFunction from '../../services/common.function';

@Injectable({
  providedIn: 'root'
})
export class SignalRService {

  constructor(private http: HttpClient) { }

  getNotificationByUserId(userId: any): Observable<any> {
   // API call of notification list
    let stTimeZone = CommonFunction.GetTimeZone();
    return this.http.get(`${environment.WebApiURL}api/Notification/GetNotificationDetailsByUserId?uiUserId=${userId}&stTimeZone=${stTimeZone}`).pipe(map((response: any) => {
      return response;
    }));
  }

  updateNotificationByUserId(): Observable<any> {
    // API call of update notification list
    return this.http.get(`${environment.WebApiURL}api/Notification/UpdateNotificationCountById`).pipe(map((response: any) => {
      return response
    }));
   }
}
